export enum LoginErrorCode {
  EMPTY_USERNAME = 'empty_username',
  EMPTY_PASSWORD = 'empty_password',
  INVALID_USERNAME = 'invalid_username',
  INVALID_EMAIL = 'invalid_email',
  INCORRECT_PASSWORD = 'incorrect_password',
  AUTHENTICATION_FAILED = 'authentication_failed',
}

export enum AuthErrorCode {
  // Common
  MISSING_PHONE = 'MISSING_PHONE',
  MISSING_OTP = 'MISSING_OTP',
  MISSING_NAME = 'MISSING_NAME',
  MISSING_EMAIL = 'MISSING_EMAIL',
  INVALID_EMAIL_FORMAT = 'INVALID_EMAIL_FORMAT',
  INVALID_OTP = 'INVALID_OTP',
  SERVER_ERROR = 'SERVER_ERROR',

  // OTP Generate
  INVALID_PHONE_FORMAT = 'INVALID_PHONE_FORMAT',
  RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED',
  SMS_DELIVERY_FAILED = 'SMS_DELIVERY_FAILED',

  // OTP Verify
  OTP_EXPIRED = 'OTP_EXPIRED',
  OTP_NOT_FOUND = 'OTP_NOT_FOUND',
  OTP_NOT_VERIFIED = 'OTP_NOT_VERIFIED',
  MAX_ATTEMPTS_EXCEEDED = 'MAX_ATTEMPTS_EXCEEDED',

  // Email Verification
  EMAIL_NOT_IN_CANDIDATES = 'EMAIL_NOT_IN_CANDIDATES',
  SESSION_NOT_FOUND = 'SESSION_NOT_FOUND',
  SESSION_LOCKED = 'SESSION_LOCKED',

  // Registration
  USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS',
  CUSTOMER_CREATION_FAILED = 'CUSTOMER_CREATION_FAILED',

  // Social OAuth (Google, Facebook)
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  EMAIL_REQUIRED = 'EMAIL_REQUIRED',
  AUTH_FAILED = 'AUTH_FAILED',
  CURRENT_PASSWORD_INCORRECT = 'CURRENT_PASSWORD_INCORRECT',
  PASSWORD_CHANGED_RETRY = 'PASSWORD_CHANGED_RETRY',
}

// OTP Generate API errors
export const OTP_GENERATE_ERROR_CODES: AuthErrorCode[] = [
  AuthErrorCode.MISSING_PHONE,
  AuthErrorCode.INVALID_PHONE_FORMAT,
  AuthErrorCode.RATE_LIMIT_EXCEEDED,
  AuthErrorCode.SMS_DELIVERY_FAILED,
];

// OTP Verify API errors
export const OTP_VERIFY_ERROR_CODES: AuthErrorCode[] = [
  AuthErrorCode.MISSING_PHONE,
  AuthErrorCode.MISSING_OTP,
  AuthErrorCode.INVALID_OTP,
  AuthErrorCode.OTP_EXPIRED,
  AuthErrorCode.OTP_NOT_FOUND,
  AuthErrorCode.MAX_ATTEMPTS_EXCEEDED,
];

// Email Verify API errors
export const EMAIL_VERIFY_ERROR_CODES: AuthErrorCode[] = [
  AuthErrorCode.MISSING_PHONE,
  AuthErrorCode.EMAIL_NOT_IN_CANDIDATES,
  AuthErrorCode.SESSION_NOT_FOUND,
  AuthErrorCode.SESSION_LOCKED,
];

// Email Verify critical errors (require redirect)
export const EMAIL_VERIFY_CRITICAL_ERROR_CODES = new Set([
  AuthErrorCode.MAX_ATTEMPTS_EXCEEDED,
  AuthErrorCode.SESSION_LOCKED,
  AuthErrorCode.SESSION_NOT_FOUND,
  AuthErrorCode.OTP_EXPIRED,
  AuthErrorCode.OTP_NOT_FOUND,
  AuthErrorCode.INVALID_OTP,
]);

// Registration API errors
export const REGISTER_ERROR_CODES: AuthErrorCode[] = [
  AuthErrorCode.MISSING_PHONE,
  AuthErrorCode.MISSING_NAME,
  AuthErrorCode.MISSING_EMAIL,
  AuthErrorCode.INVALID_EMAIL_FORMAT,
  AuthErrorCode.OTP_NOT_VERIFIED,
  AuthErrorCode.USER_ALREADY_EXISTS,
  AuthErrorCode.CUSTOMER_CREATION_FAILED,
];
